import Service from '@ember/service';

import { service } from '@ember/service';

import ENV from 'rise-ui/config/environment.js';
import routeInfoToParams from 'rise-ui/utils/route-info-to-params.js';
import { joinPaths, joinUrl } from 'rise-ui/utils/url.js';

export default class RoutingService extends Service {
  @service ssr;
  @service routeState;
  @service router;

  getTransitionInterface(routeInfo, queryParams) {
    const routeParams = routeInfo && typeof routeInfo === 'object'
      ? routeInfoToParams(routeInfo)
      : [].concat(routeInfo || []);
    const linkTo = [ ...routeParams ];
    const transitionTo = [ ...routeParams ];
    const urlParams = [ ...routeParams ];
    const routeName = routeParams[0];
    const encodedParams = this.routeState.serializeQueryParams(routeName, queryParams);
    if (queryParams) {
      linkTo.push({ isQueryParams: true, values: queryParams });
      transitionTo.push({ queryParams });
      urlParams.push({ queryParams: encodedParams });
    }
    let url = '';
    try {
      url = this.router.urlFor(...urlParams);
    } catch (e) {
      if (e.message.startsWith('There is no route named')) {
        console.error(e);
      } else {
        throw e;
      }
    }
    return Object.assign((ri, qp) => {
      return this.getTransitionInterface(
        ri || routeInfo,
        Object.assign({}, queryParams || {}, qp || {})
      );
    }, {
      linkTo,
      transitionTo,
      transition: () => url && this.router.transitionTo(...transitionTo),
      url,
      queryParams,
      encodedParams,
      routeInfo,
    });
  }

  fullUrlFor(...route) {
    const { host, protocol } = this.ssr.isSsr ? this.ssr.request : window.location;
    return joinPaths([ `${protocol}//${host}`, ENV.rootURL, this.router.urlFor(...route) ]);
  }

  get baseURL() {
    const { host, protocol } = this.ssr.isSsr ? this.ssr.request : window.location;
    return joinUrl(host, this.rootURL, protocol);
  }
}
